import { SITE_URL } from "@/lib/site";

/** Görsel veya yol için mutlak URL (JSON-LD / Open Graph) */
export function toAbsoluteUrl(pathOrUrl: string, baseUrl: string = SITE_URL): string {
  const base = baseUrl.replace(/\/$/, "");
  if (!pathOrUrl) return base;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}${path}`;
}
